<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" toggleButtonSize="small" @keyup.enter="loadAgentInboundDetailsReports(1, itemPerPage, true)">
      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" size="small" @click="exportData">{{ $t('export') }}</vs-button>
      </template>
      <div class="vx-row" id="inbound-detail-filter-container">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="searchParams.from" :model="searchParams.from" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
<!--          <v-select :options="callStatusOptions" :reduce="label => label.value" :placeholder="$t('treatment_result')" v-model="searchParams.call_status" class="md:mb-0 mb-3" />-->
          <select v-model="searchParams.call_status" class="vs-inputx vs-input--input normal md:mb-0 mb-3" style="width:100%;" >
            <option value="">{{ $t('treatment_result') }}</option>
            <option v-for="(option, key) in callStatusOptions" :key="'call_status_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="searchParams.to" :model="searchParams.to" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
<!--          <v-select :options="ivrDstOptions" :reduce="label => label.value" :placeholder="$t('ivr_staff')" v-model="searchParams.ivr_query" class="w-full mb-3" />-->
          <select v-model="searchParams.ivr_query" class="vs-inputx vs-input--input normal w-full mb-3" style="width:100%;" >
            <option value="">{{ $t('ivr_staff') }}</option>
            <option v-for="(option, key) in ivrDstOptions" :key="'ivr_staff_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
<!--          <v-select :options="didOptions" :reduce="label => label.value" :placeholder="$t('did')" v-model="searchParams.service_name" class="md:mb-3 mb-3" />-->
          <select v-model="searchParams.service_name" class="vs-inputx vs-input--input normal md:mb-3 mb-3" style="width:100%;" >
            <option value="">{{ $t('did') }}</option>
            <option v-for="(option, key) in didOptions" :key="'service_name_' + key" :value="option.value">{{ option.label }}</option>
          </select>
<!--          <v-select :options="translatedDispositionOptions" :reduce="label => label.value" :placeholder="$t('disposition')" v-model="searchParams.disposition" class="w-full mb-3" />-->
          <select v-model="searchParams.disposition" class="vs-inputx vs-input--input normal w-full mb-3" style="width:100%;" >
            <option value="">{{ $t('disposition') }}</option>
            <option v-for="(option, key) in translatedDispositionOptions" :key="'disposition_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$tc('number')" v-model="searchParams.src" class="w-full"/>
        </div>
      </div>
      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadAgentInboundDetailsReports(1, itemPerPage, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="inboundDetailsDataContainer" :title="$t('inbound_details')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-call-statistics-tab-nav></shared-call-statistics-tab-nav>
      </template>

      <shared-inbound-details-list
        :cdrDatas="cdrDatas"
        :customFields="customFields"
        :activeColumns="activeColumns"
      ></shared-inbound-details-list>

      <template slot="footer">
        <paginate
          :total="cdrPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadAgentInboundDetailsReports"
          v-model="initialPage"
          :goto="cdrLastPageKnown"
        >
        </paginate>
      </template>
    </vx-card>
  </div>
</template>

<script>
import Paginate from '@/components/Paginate'
import SharedCallStatisticsTabNav from '@/views/Shared/CallStatistics/TabNav'
import DatePicker from '@/components/form-inputs/DatePicker'
import AgentInboundDetailsReport from '@/models/AgentInboundDetailsReport'
import Pagination from '@/mixins/paginate'
import SharedInboundDetailsList from '@/views/Shared/InboundDetails/List'
import SharedUserConsultationList from '@/views/Shared/Consultations/Consultations/List.vue'

export default {
  name: 'User.CallStatistics.InboundDetails',
  mixins: [Pagination],
  components: {
    SharedUserConsultationList,
    SharedCallStatisticsTabNav,
    DatePicker,
    Paginate,
    SharedInboundDetailsList
  },
  data () {
    return {
      customFields: {},
      activeColumns: {},
      cdrDatas: {},
      cdrPages: 1,
      initialPage: typeof this.$route.query.page !== 'undefined' && this.$route.query.page > 0 ? parseInt(this.$route.query.page) : 1,
      cdrListCount: 0,
      didOptions: [],
      ivrDstOptions: [],
      dispositionOptions: [
        {
          label: 'inbound_details_statistics_outbound_answered',
          value: '응답'
        },
        {
          label: 'inbound_details_statistics_outbound_no_answered',
          value: '미 응답'
        },
        {
          label: 'BUSY',
          value: 'BUSY'
        }
      ],
      callStatusOptions: [],
      itemPerPage: 10,
      cdrLastPageKnown: false,
      searchParams: {
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : this.$momentHelper.getCurrentDate(),
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : this.$momentHelper.getCurrentDate(),
        call_status: typeof this.$route.query.call_status !== 'undefined' ? this.$route.query.call_status : '',
        service_name: typeof this.$route.query.service_name !== 'undefined' ? this.$route.query.service_name : '',
        src: typeof this.$route.query.src !== 'undefined' ? this.$route.query.src : '',
        ivr_query: typeof this.$route.query.ivr_query !== 'undefined' ? this.$route.query.ivr_query : '',
        disposition: typeof this.$route.query.disposition !== 'undefined' ? this.$route.query.disposition : ''
      },
      companyId: this.$store.getters.userInfo.company.id
    }
  },
  computed: {
    translatedDispositionOptions () {
      return this.dispositionOptions.map(option => ({
        label: this.$t(option.label),
        value: option.value
      }))
    }
  },
  mounted () {
    this.loadAgentInboundDetailsReports(this.initialPage, this.itemPerPage)
  },
  methods: {
    async loadAgentInboundDetailsReports (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#inboundDetailsDataContainer'})

      // Normalize itemPerPage
      if (typeof itemPerPage === 'number' && !isNaN(itemPerPage)) {
        this.itemPerPage = itemPerPage
      } else if (typeof this.itemPerPage === 'number' && !isNaN(this.itemPerPage)) {
        itemPerPage = this.itemPerPage
      } else {
        this.itemPerPage = 10
        itemPerPage = 10
      }

      this.$router.replace({ query: { ...this.searchParams, page, itemPerPage } })
      const response = await AgentInboundDetailsReport.findAll({ ...this.searchParams, page, itemPerPage, include_total: true })

      this.cdrDatas = response.data.data.inboundDetails

      // Determine if backend provided last_page (LengthAware) or not (Simple)
      const pagination = response.data.meta && response.data.meta.pagination ? response.data.meta.pagination : {}
      const lastPage = typeof pagination.last_page !== 'undefined' ? pagination.last_page : null
      const hasMore = typeof pagination.has_more !== 'undefined' ? pagination.has_more : null

      this.cdrLastPageKnown = lastPage !== null && lastPage !== undefined

      // Compute UI total pages: if last_page unknown, use current page plus one when has_more
      this.cdrPages = this.cdrLastPageKnown ? lastPage : (hasMore ? page + 1 : page)

      this.didOptions = response.data.meta.options.dids
      this.ivrDstOptions = response.data.meta.options.ivrDst
      this.callStatusOptions = response.data.meta.options.callStatuses
      this.activeColumns = response.data.meta.activeColumns
      this.customFields = response.data.meta.customFields

      // itemPerPage from backend if available, otherwise keep current
      if (pagination.per_page) {
        this.itemPerPage = pagination.per_page
      }

      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#inboundDetailsDataContainer > .con-vs-loading')
    },
    async exportData () {
      this.$store.dispatch('setIsMainTableLoading', true)
      const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
      await AgentInboundDetailsReport.export({ ...this.searchParams, companyId: this.companyId, language, export: true }) // TODO: Process const response =
      this.$store.dispatch('setIsMainTableLoading', false)
    }
  }
}
</script>

<style scoped>
</style>
